import { render, staticRenderFns } from "./bannerType.vue?vue&type=template&id=3ad65b32&scoped=true"
import script from "./bannerType.vue?vue&type=script&lang=js"
export * from "./bannerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad65b32",
  null
  
)

export default component.exports